function initHome1Section() {
  const fontUrl = "https://cdn.shopify.com/s/files/1/0829/4730/9898/files/SatisfySL.json?v=1773133452"

  function setupMobileVaraPosition() {
    if (window.innerWidth > 749) return;

    const pinkContent = document.querySelector('.home1-static-content');
    if (!pinkContent) return;

    let mobileSlot = pinkContent.querySelector('.mobile-vara-slot');
    if (!mobileSlot) {
      mobileSlot = document.createElement('div');
      mobileSlot.className = 'mobile-vara-slot';
      pinkContent.insertBefore(mobileSlot, pinkContent.firstChild);
    }
  }

  function drawVara(container) {
    if (!container || typeof Vara === 'undefined') return;
    
    const textToDraw = container.getAttribute('data-handwriting-text') || "Flowers";
    let cleanedText = textToDraw.trim();

    // Normalise some known labels to nicely capitalised variants
    const lower = cleanedText.toLowerCase();
    if (lower === 'on sale') {
      cleanedText = 'Fathers Day';
    } else if (lower === 'flowers') {
      cleanedText = 'Flowers';
    } else if (lower === 'plants') {
      cleanedText = 'Plants';
    } else if (lower === 'gifting') {
      cleanedText = 'Gifting';
    }

    const isWeddingText = cleanedText === 'Fathers Day';
    const textWithDots = cleanedText ? `${cleanedText}...` : '';
    container.innerHTML = '';

    const slider = document.querySelector('.home1-image-slider');
    const speedSeconds = slider && slider.dataset && slider.dataset.speed
      ? parseFloat(slider.dataset.speed)
      : 5;

    const slideDurationMs = speedSeconds * 1000;
    const isWeddingSlide = isWeddingText;

    // Make non‑wedding slides (Flowers / Plants / Gifting) write noticeably faster
    const fastFactor = 0.5; // 50% of base duration for non‑wedding

    const drawDuration = isWeddingSlide
      ? slideDurationMs - 300              // keep long, almost full slide duration
      : slideDurationMs * fastFactor;      // faster handwriting for the other three

    const spacing = isWeddingSlide ? 3 : 6;

    const extraSeconds = isWeddingSlide ? 1.5 : 0;
    // Make slider controls / autoplay slightly faster than the original speed
    const controlFactor = 0.9; // 90% of base duration for all slides
    const baseControlDuration = speedSeconds * controlFactor;
    const totalDuration = baseControlDuration + extraSeconds;

    const homeSec1 = document.querySelector('.home-sec1');
    if (homeSec1) {
      homeSec1.style.setProperty('--slide-progress-duration', totalDuration + 's');
    }

    const sc = document.querySelector('slideshow-component');
    if (sc && typeof sc.play === 'function') {
      sc.autoplaySpeed = totalDuration * 1000;
      sc.play();
    }

    const isMobile = window.innerWidth <= 749;
    const isTablet = window.innerWidth >= 750 && window.innerWidth <= 989;

    // On mobile, draw into the shared slot inside the pink box instead
    let drawTarget = container;
    if (isMobile) {
      const pinkContent = document.querySelector('.home1-static-content');
      const mobileSlot = pinkContent && pinkContent.querySelector('.mobile-vara-slot');
      if (mobileSlot) {
        mobileSlot.innerHTML = '';
        mobileSlot.id = container.id + '-mobile';
        drawTarget = mobileSlot;
      }
    }

    const fontSize  = isMobile ? 10 : isTablet ? 16 : 22;
    const strokeW   = isMobile ? 4  : isTablet ? 2.5 : 3;
    const textColor = isMobile ? "#1e1e1e" : "#ffffff";

    new Vara("#" + drawTarget.id, fontUrl, [{
      text: textWithDots,
      fontSize: fontSize,
      strokeWidth: strokeW,
      textAlign: "center",
      duration: drawDuration,
      color: textColor
    }], {
      letterSpacing: spacing
    });
  }

  // Per-slide Shop Now links keyed by slide class
  const slideLinks = {
    // Slide 1: Flowers (uses default link)
    'home1-autumn':    null,
    // Slide 2: Gifting
    'home1-plants':    'https://www.flowerstation.co.uk/pages/flower-station-gifting',
    // Slide 3: Plants
    'home1-gifting':   'https://www.flowerstation.co.uk/collections/planted-gifts',
    // Slide 4: Weddings & Events
    'home1-christmas': 'https://www.flowerstation.co.uk/collections/fathers-day-flowers'
  };

  // Store defaults once on load — used to reset when a slide has no custom value
  const defaultBtnLink = (function() {
    const a = document.querySelector('.home1-content .home1-buttons a:first-child');
    return a ? a.getAttribute('href') : '/collections/all-flowers';
  })();
  const defaultBtnLabel = (function() {
    const btn = document.querySelector('.home1-buttons button');
    return btn ? btn.textContent.trim() : 'Shop Now';
  })();
  const defaultLogoSrc = (function() {
    const logo = document.querySelector('.home1-logo');
    return logo ? logo.src : '';
  })();

  function updateSlideContent(slide) {
    if (!slide) return;

    const content = document.querySelector('.home1-static-content');
    const allBtns = document.querySelectorAll('.home1-buttons button, .home1-buttons-mob button');
    const desktopBtns = document.querySelectorAll('.home1-buttons button');
    const allLinks = document.querySelectorAll('.home1-content .home1-buttons a:first-child, .home1-buttons-mob a:first-child');
    const logo = document.querySelector('.home1-logo');

    // Icon — reset to default if slide has none
    if (logo) logo.src = slide.dataset.iconUrl || defaultLogoSrc;

    // Background — clear inline style so CSS takes over if slide has none
    if (content) content.style.background = slide.dataset.boxBg || '';

    // Button label — applies to all buttons including mobile
    allBtns.forEach(btn => { btn.textContent = slide.dataset.btnLabel || defaultBtnLabel; });

    // Button colors — desktop only; mobile stays fixed #F599A7 from CSS
    desktopBtns.forEach(btn => {
      btn.style.background = slide.dataset.btnBg || '';
      btn.style.borderColor = slide.dataset.btnBg || '';
      btn.style.color = slide.dataset.btnText || '';
    });

    // Button link — data attribute first, then class-based fallback, then global default
    let href = defaultBtnLink;
    if (slide.dataset.btnLink) {
      href = slide.dataset.btnLink;
    } else {
      for (const cls in slideLinks) {
        if (slide.classList.contains(cls) && slideLinks[cls]) { href = slideLinks[cls]; break; }
      }
    }
    allLinks.forEach(a => a.setAttribute('href', href));
  }

  function updateShopNowLink(slide) {
    updateSlideContent(slide);
  }

  function getVisibleSlide(slides) {
    return Array.from(slides).find(slide => {
      const rect = slide.getBoundingClientRect();
      return rect.left >= -10 && rect.left < window.innerWidth / 2;
    }) || slides[0];
  }

  function initVaraSlideshow() {
    if (typeof Vara === 'undefined') {
      window.initVaraWhenReady = initVaraSlideshow;
      return;
    }

    const slides = document.querySelectorAll('.home1-image-slide');
    if (!slides.length) return;

    slides.forEach(slide => {
      const c = slide.querySelector('.custom-handwritten-text');
      if (c) c.innerHTML = '';
    });

    const visibleSlide = getVisibleSlide(slides);
    updateShopNowLink(visibleSlide);
    const visibleContainer = visibleSlide.querySelector('.custom-handwritten-text');
    if (visibleContainer) drawVara(visibleContainer);

    // Track which slide last had Vara drawn so scroll + mutation don't double-draw
    let lastVaraSlide = visibleSlide;

    function activateSlide(slide) {
      if (!slide || slide === lastVaraSlide) return;
      lastVaraSlide = slide;
      updateShopNowLink(slide);
      slides.forEach(s => {
        if (s !== slide) {
          const c = s.querySelector('.custom-handwritten-text');
          if (c) c.innerHTML = '';
        }
      });
      const container = slide.querySelector('.custom-handwritten-text');
      if (container && container.innerHTML === '') {
        const delay = window.innerWidth <= 749 ? 0 : 200;
        setTimeout(() => drawVara(container), delay);
      }
    }

    // Primary: scroll-based — fires even when `inert` was never set on a slide
    // (happens on the first auto-play transition if sliderItemsToShow wasn't populated at init)
    const sliderEl = document.querySelector('.home1-image-slider');
    if (sliderEl) {
      let scrollTimer;
      sliderEl.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          activateSlide(getVisibleSlide(slides));
        }, 150);
      });
    }

    // Fallback: mutation-based for inert / is-active / aria-hidden transitions
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const target = mutation.target;

        if (mutation.attributeName === 'inert') {
          if (!target.hasAttribute('inert')) {
            activateSlide(target);
          } else {
            const container = target.querySelector('.custom-handwritten-text');
            if (container) container.innerHTML = '';
          }
          return;
        }

        const isActive =
          target.classList.contains('is-active') ||
          target.getAttribute('aria-hidden') === 'false';

        if (isActive) {
          activateSlide(target);
        } else {
          const container = target.querySelector('.custom-handwritten-text');
          if (container) container.innerHTML = '';
        }
      });
    });

    slides.forEach(slide => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'inert', 'data-box-bg', 'data-btn-bg', 'data-btn-text', 'data-btn-label', 'data-btn-link', 'data-icon-url'] });
    });
  }

  const _slides = document.querySelectorAll('.home1-image-slide');
  if (_slides.length) {
    const _visible = getVisibleSlide(_slides);
    if (_visible) updateSlideContent(_visible);
  }

  setupMobileVaraPosition();

  initVaraSlideshow();
}

function loadVara() {
  const el = document.querySelector('.home-sec1');
  const url = el && el.dataset.varaUrl;
  if (!url || typeof Vara !== 'undefined') return;
  const s = document.createElement('script');
  s.src = url;
  s.onload = function() {
    if (window.initVaraWhenReady) {
      window.initVaraWhenReady();
    }
  };
  document.head.appendChild(s);
}

// Load Vara only when its section scrolls into view and the main thread is idle.
(function scheduleVaraWithIO() {
  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() { setTimeout(loadVara, 400); }, { timeout: 2500 });
    } else {
      setTimeout(loadVara, 1000);
    }
  }

  const el = document.querySelector('.home-sec1');
  if (!el) { return; }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      schedule();
    }, { threshold: 0.1 });
    io.observe(el);
  } else {
    window.addEventListener('load', schedule);
  }
}());

// Run on normal page load OR immediately if DOM is already ready (theme editor section reload)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHome1Section);
} else {
  initHome1Section();
}

// Re-run when Shopify theme editor reloads the section after a settings change
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('home-section-1')) {
    initHome1Section();
  }
});

document.addEventListener('shopify:block:select', function(event) {
  const slides = document.querySelectorAll('.home1-image-slide');
  if (!slides.length) return;
  const rect = slides[0].getBoundingClientRect();
  const visibleSlide = Array.from(slides).find(s => {
    const r = s.getBoundingClientRect();
    return r.left >= -10 && r.left < window.innerWidth / 2;
  }) || slides[0];
  if (visibleSlide) {
    const content = document.querySelector('.home1-static-content');
    const allBtns = document.querySelectorAll('.home1-buttons button, .home1-buttons-mob button');
    const allLinks = document.querySelectorAll('.home1-content .home1-buttons a:first-child, .home1-buttons-mob a:first-child');
    const logo = document.querySelector('.home1-logo');
    const desktopBtns = document.querySelectorAll('.home1-buttons button');
    if (logo && visibleSlide.dataset.iconUrl) logo.src = visibleSlide.dataset.iconUrl;
    if (content) content.style.background = visibleSlide.dataset.boxBg || '';
    allBtns.forEach(btn => { if (visibleSlide.dataset.btnLabel) btn.textContent = visibleSlide.dataset.btnLabel; });
    desktopBtns.forEach(btn => {
      btn.style.background = visibleSlide.dataset.btnBg || '';
      btn.style.borderColor = visibleSlide.dataset.btnBg || '';
      btn.style.color = visibleSlide.dataset.btnText || '';
    });
    allLinks.forEach(a => { if (visibleSlide.dataset.btnLink) a.setAttribute('href', visibleSlide.dataset.btnLink); });
  }
});
